<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 pb-12 hidden">
    <router-link to="/userProjects">
      <a
        href="#"
        class="relative inline-flex items-center my-4 py-2 leading-5 font-medium text-lg font-semibold
         transition ease-in-out duration-150 text-lightFont hover:text-darkFont uppercase"
      >
        <LeftArrow class="mr-2" /> Back to Show &amp; Tell
      </a>
    </router-link>
    <Card>
      <div class="py-16  mt-2 px-4 sm:px-6 lg:px-8" v-if="project">
        <div class="max-w-7xl mx-auto">
          <div class="relative z-10 mb-8 md:mb-2 md:px-6">
            <div class="text-base max-w-prose lg:max-w-none">
              <p
                class="text-base leading-6 text-darkgreen  tracking-wide uppercase text-2xl tracking-wider"
              >
                {{ project.yourName }}
              </p>
              <h1
                class="mt-4 mb-8 font-open-sans text-5xl leading-10 font-bold leading-snug tracking-wider text-gray-900 "
              >
                {{ project.projectTitle }}
              </h1>
            </div>
          </div>
          <div class="relative">
            <div class="relative bg-white md:p-6">
              <div class="lg:grid lg:grid-cols-2 lg:gap-6 mb-8">
                <!--              First column -->
                <div class="mb-6 lg:max-w-none lg:mb-0">
                  <iframe
                    v-if="hasVideo"
                    width="500px"
                    height="280px"
                    class="w-full"
                    :src="youtubeUrl"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  >
                  </iframe>

                  <simple-gallery
                    v-if="!hasVideo && imgUrls && imgUrls.length > 0"
                    :images="imgUrls"
                  ></simple-gallery>

                  <div class="mt-2 mb-5">
                    <reaction-bar :document-id="project._id"></reaction-bar>
                  </div>
                  <hr class="mt-2 border-vectric" />
                  <div
                    class="flex justify-center items-center"
                    v-if="isAdmin && !project.allowMarketing"
                  >
                    <vectric-admin-tool></vectric-admin-tool>
                    <h1
                      class="text-xl leading-10 font-extrabold tracking-wider text-red"
                    >
                      Permission has not been given for marketing
                    </h1>
                  </div>

                  <vue-markdown
                    :source="project.projectDescription"
                    :anchorAttributes="{ target: '_blank' }"
                    class="text-gray-700 text-base prose pt-7"
                  ></vue-markdown>

                  <question-answer
                    question="What was your inspiration?"
                    :answer="project.inspiration"
                    class="mt-10"
                  ></question-answer>
                  <question-answer
                    question="What materials were used?"
                    :answer="project.materialsUsed"
                    class="mt-10"
                  ></question-answer>
                  <question-answer
                    question="What size is your project"
                    :answer="project.projectSize"
                    class="mt-10"
                  ></question-answer>
                  <question-answer
                    question="What tools & finishes were used?"
                    :answer="project.finishes"
                    class="mt-10"
                  ></question-answer>
                  <question-answer
                    question="If you did it again, what would you do differently?"
                    :answer="project.hindsight"
                    class="mt-10"
                  ></question-answer>
                  <simple-gallery
                    :images="imgUrls"
                    v-if="hasVideo && imgUrls && imgUrls.length > 0"
                  ></simple-gallery>
                </div>

                <!--              second column -->
                <div class="text-gray-500">
                  <Label>Comments</Label>
                  <div class="mt-2">
                    <project-comment-area
                      :sanity-document-id="project._id"
                    ></project-comment-area>
                  </div>
                </div>
              </div>

              <div class="mt-6"></div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
window.location.href = "/";
import { sanityClient } from "../utils/sanity";
import VueMarkdown from "vue-markdown";
import ProjectCommentArea from "../components/ProjectCommentArea";
import ReactionBar from "../components/ReactionBar";
import {
  VueFlux,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader
} from "vue-flux";
import QuestionAnswer from "../components/QuestionAnswer";
import SimpleGallery from "../components/SimpleGallery";
import { mapGetters } from "vuex";
import VectricAdminTool from "../components/VectricAdminTool";
import sanityImageBuilder from "../utils/sanityImageBuilder";
import Card from "../components/shared/Card.vue";
import Label from "../components/shared/Label.vue";
import LeftArrow from "../components/shared/LeftArrow.vue";

export default {
  name: "Project",
  components: {
    LeftArrow,
    Label,
    Card,
    VectricAdminTool,
    SimpleGallery,
    VueMarkdown,
    QuestionAnswer,
    ProjectCommentArea,
    ReactionBar
  },
  data() {
    return {
      vfOptions: {
        autoplay: false,
        allowFullscreen: true
      },
      vfTransitions: [
        {
          name: "slide",
          options: {
            totalDuration: 1400,
            easing: "ease-in-out"
          }
        }
      ],
      project: null
    };
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    hasVideo() {
      return (
        this.project.youtube !== null &&
        this.project.youtube !== undefined &&
        this.project.youtube.length > 0
      );
    },
    youtubeUrl() {
      return "https://youtube.com/embed/" + this.project.youtube;
    },
    imgUrls() {
      if (this.project.uploadedImages) {
        return this.project.uploadedImages.map(img =>
          sanityImageBuilder.image(img).url()
        );
      } else {
        return [];
      }
    }
  },
  created() {
    const id = this.$route.params.sanityProjectId;
    const queryString = "*[_type == 'userProject' && _id == $id][0]{...}";
    sanityClient
      .fetch(queryString, { id })
      .then(res => {
        this.project = res;
      })
      .catch(function(err) {
        console.log(err);
      });
  }
};
</script>
